import { render, staticRenderFns } from "./TempConfigFormItemSet.vue?vue&type=template&id=10b5f1c5&scoped=true"
import script from "./TempConfigFormItemSet.vue?vue&type=script&lang=js"
export * from "./TempConfigFormItemSet.vue?vue&type=script&lang=js"
import style0 from "./TempConfigFormItemSet.vue?vue&type=style&index=0&id=10b5f1c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b5f1c5",
  null
  
)

export default component.exports